import { AuthSession, fetchAuthSession } from "aws-amplify/auth";

/**
 * This function creates a singleton that fetches the current session. This is necessary
 * because the Amplify fetchAuthSession method does not de-duplicate credential requests to
 * the Cognito server. That means that duplicate requests will be made to the server if
 * multiple components call fetchAuthSession concurrently before the internal credential
 * cache has been populated. This singleton ensures that only one request is made at a time.
 *
 * A feature request has been made to the Amplify team to add de-duplication
 * to the fetchAuthSession method. If that feature is added, this layer of
 * abstraction can be removed.
 *
 * @see https://github.com/aws-amplify/amplify-js/issues/13499
 */
function createFetchAuthSessionDedupeSingleton() {
  let pendingRequest: Promise<AuthSession> | null = null;

  return () => {
    if (!pendingRequest) {
      pendingRequest = new Promise(async (resolve, reject) => {
        try {
          const response = await fetchAuthSession();
          resolve(response);
        } catch (error) {
          console.error("Error fetching auth session:", error);
          reject(error);
        } finally {
          pendingRequest = null;
        }
      });
    }

    return pendingRequest;
  };
}

export const fetchAuthSessionDedupe = createFetchAuthSessionDedupeSingleton();
